import React from 'react';

const PROCESS_STEPS = [
  {
    num: '01',
    title: 'Discovery & Scope',
    desc: 'We discuss your goals, operational bottlenecks, and technical requirements to define a clear project blueprint.',
    accentColor: '#1a2f6e',
  },
  {
    num: '02',
    title: 'UX & Architecture',
    desc: 'We design user flows and clickable prototypes so you can test how the application works before coding begins.',
    accentColor: '#4caf50',
  },
  {
    num: '03',
    title: 'Agile Development',
    desc: 'We build your application in short, focused sprints with live weekly demos to incorporate your feedback.',
    accentColor: '#0d9488',
  },
  {
    num: '04',
    title: 'Testing & Launch',
    desc: 'Rigorous speed, security, and device testing to ensure a smooth deployment to production servers.',
    accentColor: '#f97316',
  },
  {
    num: '05',
    title: 'Maintenance & Growth',
    desc: 'Ongoing support, proactive monitoring, and feature upgrades to keep your system performing at its best.',
    accentColor: '#1a2f6e',
  },
];

const HowWeWorkSection = () => {
  return (
    <section className="py-5 sipl-section-tint-translucent" aria-label="Our Process" style={{ position: 'relative', zIndex: 1 }}>
      <div className="container py-4">

        <div className="row mb-5 justify-content-center text-center">
          <div className="col-12 col-lg-8 sipl-reveal-ttb">
            <span className="text-uppercase fw-bold sipl-text-teal tracking-wider small d-block mb-2" style={{ letterSpacing: '0.12em' }}>
              HOW WE WORK
            </span>
            <h2 className="display-6 fw-bold text-dark mb-3">
              A clear, transparent delivery process.
            </h2>
            <p className="text-muted fs-6 mx-auto" style={{ maxWidth: '680px', lineHeight: '1.7' }}>
              Every project has unique requirements, but our development workflow ensures you stay informed, involved, and in control from concept to launch.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {PROCESS_STEPS.map((step, i) => {
            const revealDirections = [
              'sipl-reveal-ltr',
              'sipl-reveal-ttb',
              'sipl-reveal-btt',
              'sipl-reveal-ttb',
              'sipl-reveal-rtl',
            ];
            const dirClass = revealDirections[i % revealDirections.length];
            return (
              <div key={step.num} className={`col-12 col-sm-6 col-lg ${dirClass}`} style={{ transitionDelay: `${i * 0.14}s` }}>
                <div
                  className="sipl-process-card p-4 h-100 shadow-sm"
                  style={{
                    '--step-accent': step.accentColor,
                    background: '#ffffff',
                    borderRadius: '18px',
                    border: '1px solid #e2e8f0',
                    borderTop: `4px solid ${step.accentColor}`,
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <span className="sipl-process-badge fw-bold" style={{ backgroundColor: step.accentColor }}>
                      {step.num}
                    </span>
                    {i < PROCESS_STEPS.length - 1 && (
                      <span className="sipl-process-arrow d-none d-lg-block">→</span>
                    )}
                  </div>
                  <h3 className="sipl-process-title">{step.title}</h3>
                  <p className="sipl-process-desc">{step.desc}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default HowWeWorkSection;
